import { EnvFull } from "./environment.model";

export const environment: EnvFull = {
    production: true,
    api_url: "https://api.harvestr.io"
};
